import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import ResetPasswordForm from '@/components/auth/ResetPasswordForm';

const ResetPasswordPage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, loading } = useAuth();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  // Redirect if already authenticated
  useEffect(() => {
    if (!loading && isAuthenticated) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, loading, navigate]);

  // Redirect if no token provided
  useEffect(() => {
    if (!loading && !token) {
      navigate('/auth/forgot-password', { replace: true });
    }
  }, [token, loading, navigate]);

  // Don't render anything while checking auth or if already authenticated
  if (loading || isAuthenticated || !token) {
    return null;
  }

  return <ResetPasswordForm token={token} />;
};

export default ResetPasswordPage;
